/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import Page from '../../lib/page';
import { getComplaintsPageInfo } from '../../lib/globalHelper';

/**
 * UK Complaints Page
 */
const BrexitComponent = (props) => {
  const {
    disputeLinkClick, financialLinkClick, complaintsLinkClick, renderCommonQuestions, renderContactChannels,
  } = props;

  const complaintsTextInfo = getComplaintsPageInfo();

  const financialUrl = `https://${complaintsTextInfo.financialDataUrl}`;

  return (
    <div className="brexit-complaints-page">
      <div className="brexit-complaints-page-div">
        <p className="brexit-complaints-page-div__intro-text">{complaintsTextInfo.introText}</p>
        <p className="brexit-complaints-page-div__dispute-text">
          {complaintsTextInfo.disputeText}
          <a href={Page.getResolutionURL()} onClick={() => disputeLinkClick()}> open a dispute.</a>
        </p>
        {renderCommonQuestions}
        {renderContactChannels}
        <h3 className="brexit-complaints-page-div__next-header">{complaintsTextInfo.nextLabel}</h3>
        <p className="brexit-complaints-page-div__response-text">{complaintsTextInfo.responseText}</p>
        <h3 className="brexit-complaints-page-div__after-response-header">{complaintsTextInfo.afterResponseLabel}</h3>
        <p className="brexit-complaints-page-div__after-response-text">
          {complaintsTextInfo.afterResponseText}
          <a href={financialUrl} onClick={() => financialLinkClick()} target="_blank" rel="noreferrer">{complaintsTextInfo.financialDataUrl}</a>
        </p>
        <h3 className="brexit-complaints-page-div__complaints-data-header">{complaintsTextInfo.complaintsData}</h3>
        <p className="brexit-complaints-page-div__complaints-data-summary">
          {complaintsTextInfo.complaintsSummary}
          <a href={complaintsTextInfo.complaintsDataUrl} onClick={() => complaintsLinkClick()} target="_blank" rel="noreferrer">{complaintsTextInfo.complaintsDataLinkText}</a>
          {complaintsTextInfo.complaintsSummaryDuration}
        </p>
      </div>
    </div>
  );
};

BrexitComponent.propTypes = {
  disputeLinkClick: PropTypes.func.isRequired,
  financialLinkClick: PropTypes.func.isRequired,
  complaintsLinkClick: PropTypes.func.isRequired,
  renderCommonQuestions: PropTypes.func.isRequired,
  renderContactChannels: PropTypes.func.isRequired,
};

export default BrexitComponent;
